module.exports = __webpack_public_path__ + "img/linkedin.53d32461.png";